'use client';

import { useRouter } from 'next/navigation';
import React from 'react';
import { toast } from 'react-toastify';
import { useDeleteClientMutation } from '@/app/(main)/client-detail/hooks/useDeleteClientMutation';
import { ConfirmModal } from '@/app/components/ConfirmModal';
import { INTERNAL_CLIENTS_PATH } from '@/consts/paths';
import TrashIcon from '/public/icons/trash.svg';

interface DeleteClientModalProps {
  isOpen: boolean;
  onClose: () => void;
  targetClientId?: number;
  suppressSuccessRedirect?: boolean;
  onSuccess?: () => void;
}

export const DeleteClientModal: React.FC<DeleteClientModalProps> = ({
  isOpen,
  onClose,
  targetClientId,
  suppressSuccessRedirect,
  onSuccess,
}) => {
  const { mutate: deleteClient, isPending } = useDeleteClientMutation();
  const router = useRouter();

  const handleConfirm = () => {
    deleteClient(targetClientId != null ? { targetClientId } : undefined, {
      onSuccess: () => {
        onSuccess?.();
        onClose();
        toast.success('Client deleted successfully');
        if (!suppressSuccessRedirect) {
          router.push(INTERNAL_CLIENTS_PATH);
        }
      },
    });
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={
        <>
          Are you sure you want
          <br />
          to delete this client?
        </>
      }
      description="This action cannot be undone. The client and all associated data will be permanently removed."
      confirmLabel="Delete"
      confirmIcon={<TrashIcon className="w-4 h-4" />}
      isPending={isPending}
    />
  );
};
